import { type FC } from 'react';
import classnames from 'classnames';
import { useFragment, graphql } from 'react-relay';
import { useLoggedInUser } from 'dibs-buyer-layout/exports/useLoggedInUser.ts';
import { NftPublicProfileEditableMedia } from './NftPublicProfileEditableMedia.tsx';

import { type NftPublicProfileMedia_publicProfile$key } from './__generated__/NftPublicProfileMedia_publicProfile.graphql.ts';

import styles from './NftPublicProfileMedia.scss';

type Props = {
    publicProfile: NftPublicProfileMedia_publicProfile$key | null | undefined;
};

export const NftPublicProfileMedia: FC<Props> = ({ publicProfile: publicProfileRef }) => {
    const currentUserId = useLoggedInUser();
    const publicProfile = useFragment(
        graphql`
            fragment NftPublicProfileMedia_publicProfile on PublicProfile {
                userId
                username
                avatarImage {
                    path
                }
                heroImage {
                    path
                }
                ...NftPublicProfileEditableMedia_publicProfile
            }
        `,
        publicProfileRef
    );

    const { heroImage, avatarImage, username, userId } = publicProfile ?? {};
    const coverPath = heroImage?.path;
    const avatarPath = avatarImage?.path;

    if (currentUserId === userId) {
        return (
            <div className={styles.container}>
                <NftPublicProfileEditableMedia publicProfile={publicProfile} />
            </div>
        );
    }

    return (
        <div
            className={classnames(styles.container, {
                [styles.noMargin]: !coverPath || !avatarPath,
            })}
        >
            {coverPath ? (
                <div
                    className={classnames(styles.coverContainer, {
                        [styles.noAvatar]: !avatarPath,
                    })}
                >
                    <img src={coverPath} alt={`${username}-cover`} className={styles.coverImage} />
                </div>
            ) : null}

            {avatarPath ? (
                <div
                    className={classnames(styles.avatarContainer, { [styles.noCover]: !coverPath })}
                >
                    <img src={avatarPath} alt={username ?? ''} className={styles.avatarImage} />
                </div>
            ) : null}
        </div>
    );
};
